import type { RouteLocationNormalized } from 'vue-router'

const PublicCoordinatorQuestionnaireView = () =>
  import('@/views/publicCoordinatorQuestionnaire/PublicCoordinatorQuestionnaireView.vue')
const PublicCoordinatorQuestionnaireSummary = () =>
  import('@/views/publicCoordinatorQuestionnaire/PublicCoordinatorQuestionnaireSummary.vue')

export default [
  {
    path: '/ankieta-koordynatora/podsumowanie',
    name: 'PublicCoordinatorQuestionnaireSummary',
    component: PublicCoordinatorQuestionnaireSummary,
    meta: {
      title: 'Ankieta Koordynatora Szkolnego'
    },
    beforeEnter: async (_to: RouteLocationNormalized, from: RouteLocationNormalized) => {
      if (from.name !== 'PublicCoordinatorQuestionnaire') {
        return { name: 'NotFound' }
      }
      return true
    }
  },
  {
    path: '/ankieta-koordynatora/:hash',
    name: 'PublicCoordinatorQuestionnaire',
    component: PublicCoordinatorQuestionnaireView,
    props: true,
    meta: {
      title: 'Ankieta Koordynatora Szkolnego'
    }
  }
]
